import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginMutationVariables = Types.Exact<{
  loginInput: Types.LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', Login: { __typename?: 'SessionEntity', accessToken?: string | null, headToURL?: string | null, selectedFirmAccount?: string | null, Entity?: { __typename?: 'Entity', id: string, Users?: { __typename?: 'UserEntity', email?: string | null, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, firstName: string, lastName: string, birthday?: any | null, ssn?: string | null, profilePhoto?: string | null } | null } | null } | null, RelatedFirms?: Array<{ __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, createAt: any } | null, Users?: { __typename?: 'UserEntity', UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null }> | null, UserFirmAccount?: { __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, createAt: any, type: Types.FirmAccountType, businessType: Types.BusinessType, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, updateAt: any, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, lastName: string, firstName: string, createAt?: any | null, updateAt?: any | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType, createAt: any, updateAt: any }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, createAt: any, updateAt: any }> | null } | null } | null, BusinessInformation?: { __typename?: 'BusinessInformationEntity', id?: string | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType, createAt: any, updateAt: any }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, createAt: any, updateAt: any }> | null } | null, ProgressStatuses?: Array<{ __typename?: 'ProgressStatusesEntity', id: string, firmAccountId: string, status: string, createAt: any, updateAt: any, underlyingStatus: Types.TaxYearStatus, index: number }> | null } | null, Entity?: { __typename?: 'Entity', id: string, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, languageId?: string | null, createAt: any, UserInformation?: { __typename?: 'UserInformationEntity', id: string, firstName: string, lastName: string, birthday?: any | null, ssn?: string | null, profilePhoto?: string | null } | null } | null } | null, Users?: { __typename?: 'UserEntity', email?: string | null, languageId?: string | null, createAt: any, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, firstName: string, lastName: string, birthday?: any | null, ssn?: string | null, profilePhoto?: string | null } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null } | null } };

export type LoginAsFirmMutationVariables = Types.Exact<{
  userId: Types.Scalars['String'];
  token: Types.Scalars['String'];
  firmId: Types.Scalars['String'];
}>;


export type LoginAsFirmMutation = { __typename?: 'Mutation', LoginAsFirm: { __typename?: 'SessionEntity', accessToken?: string | null, headToURL?: string | null, selectedFirmAccount?: string | null, RelatedFirms?: Array<{ __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, createAt: any } | null, Users?: { __typename?: 'UserEntity', UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null }> | null, UserFirmAccount?: { __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, createAt: any, businessType: Types.BusinessType, BusinessInformation?: { __typename?: 'BusinessInformationEntity', id?: string | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, createAt: any, updateAt: any, type: Types.PhoneType }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, createAt: any, updateAt: any }> | null } | null, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, firstName: string, lastName: string, birthday?: any | null, profilePhoto?: string | null, ssn?: string | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType, createAt: any, updateAt: any }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, createAt: any, updateAt: any }> | null } | null } | null, ProgressStatuses?: Array<{ __typename?: 'ProgressStatusesEntity', id: string, firmAccountId: string, status: string, createAt: any, updateAt: any, underlyingStatus: Types.TaxYearStatus, index: number }> | null } | null, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, firstName: string, lastName: string, birthday?: any | null, profilePhoto?: string | null, ssn?: string | null } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null } | null } };


export const LoginDocument = gql`
    mutation Login($loginInput: LoginInput!) {
  Login(loginInput: $loginInput) {
    accessToken
    headToURL
    selectedFirmAccount
    Entity {
      id
      Users {
        email
        languageId
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          ssn
          profilePhoto
        }
      }
    }
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
        type
        businessType
        Users {
          id
          email
          createAt
          updateAt
          languageId
          UserInformation {
            id
            userId
            birthday
            lastName
            firstName
            createAt
            updateAt
            Phones {
              id
              value
              type
              createAt
              updateAt
            }
            Address {
              id
              lineOne
              lineTwo
              city
              state
              type
              zip
              createAt
              updateAt
            }
          }
        }
        BusinessInformation {
          id
          Phones {
            id
            value
            type
            createAt
            updateAt
          }
          Address {
            id
            lineOne
            lineTwo
            city
            state
            type
            zip
            createAt
            updateAt
          }
        }
        ProgressStatuses {
          id
          firmAccountId
          status
          createAt
          updateAt
          underlyingStatus
          index
        }
      }
      Entity {
        id
        Users {
          id
          email
          languageId
          createAt
          UserInformation {
            id
            firstName
            lastName
            birthday
            ssn
            profilePhoto
          }
        }
      }
      Users {
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          ssn
          profilePhoto
        }
        email
        languageId
        createAt
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      loginInput: // value for 'loginInput'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginAsFirmDocument = gql`
    mutation LoginAsFirm($userId: String!, $token: String!, $firmId: String!) {
  LoginAsFirm(userId: $userId, token: $token, firmId: $firmId) {
    accessToken
    headToURL
    selectedFirmAccount
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
        businessType
        BusinessInformation {
          id
          Phones {
            id
            value
            createAt
            updateAt
            type
          }
          Address {
            id
            lineOne
            lineTwo
            city
            state
            type
            zip
            createAt
            updateAt
          }
        }
        Users {
          id
          email
          languageId
          UserInformation {
            id
            firstName
            lastName
            birthday
            profilePhoto
            ssn
            Phones {
              id
              value
              type
              createAt
              updateAt
            }
            Address {
              id
              lineOne
              lineTwo
              city
              state
              type
              zip
              createAt
              updateAt
            }
          }
        }
        ProgressStatuses {
          id
          firmAccountId
          status
          createAt
          updateAt
          underlyingStatus
          index
        }
      }
      Users {
        id
        email
        languageId
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          profilePhoto
          ssn
        }
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
export type LoginAsFirmMutationFn = Apollo.MutationFunction<LoginAsFirmMutation, LoginAsFirmMutationVariables>;

/**
 * __useLoginAsFirmMutation__
 *
 * To run a mutation, you first call `useLoginAsFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAsFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAsFirmMutation, { data, loading, error }] = useLoginAsFirmMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      token: // value for 'token'
 *      firmId: // value for 'firmId'
 *   },
 * });
 */
export function useLoginAsFirmMutation(baseOptions?: Apollo.MutationHookOptions<LoginAsFirmMutation, LoginAsFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAsFirmMutation, LoginAsFirmMutationVariables>(LoginAsFirmDocument, options);
      }
export type LoginAsFirmMutationHookResult = ReturnType<typeof useLoginAsFirmMutation>;
export type LoginAsFirmMutationResult = Apollo.MutationResult<LoginAsFirmMutation>;
export type LoginAsFirmMutationOptions = Apollo.BaseMutationOptions<LoginAsFirmMutation, LoginAsFirmMutationVariables>;
export const namedOperations = {
  Mutation: {
    Login: 'Login',
    LoginAsFirm: 'LoginAsFirm'
  }
}